import React from 'react';
import { ChildProps } from '@apollo/client/react/hoc';
import { gql } from '@apollo/client';
import I18n from 'i18n-js';
import CMSListingsCollection from '@reverbdotcom/commons/src/cms/components/cms_listings_collection';
import { Paths } from '@reverbdotcom/commons/src/url_helpers';
import { HomepageDealsAndStealsListingsQuery, reverb_search_ListingsSearchRequest_Sort } from '@reverbdotcom/commons/src/rql';
import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';

interface ExternalProps {
  mpid?: string;
}

type Props = ChildProps<ExternalProps, HomepageDealsAndStealsListingsQuery.Query>;

const REVERB_MERCH_SHOP_ID = '21452';
const REVERB_DIGITAL_SHOP_ID = '237252';
const EXCLUDED_SHOP_IDS = [REVERB_MERCH_SHOP_ID, REVERB_DIGITAL_SHOP_ID];

export function MostWatchedListings(props: Props) {
  const { data } = props;
  const user = useUser();
  const topCategoryUuids = data?.me?.profile?.topCategoryUuids.length ? [data?.me?.profile?.topCategoryUuids[0]] : [];
  const topCategories = data?.me?.profile?.topCategories[0] || [];

  let title = I18n.t('discovery.homepage.mostWatchedMusicGear');

  if (topCategoryUuids.length) {
    const categoryName = I18n.t(`discovery.taxonomy.${ topCategoryUuids[0]}`);
    title = I18n.t('discovery.homepage.mostWatched', { categoryName: categoryName });
  }


  return (
    <CMSListingsCollection
      ctaTargetHref={Paths.marketplace.expand({ sort: 'watchers_count|desc', product_type: topCategories[0] })}
      categoryUuids={topCategoryUuids}
      sort={reverb_search_ListingsSearchRequest_Sort.WATCHERS_COUNT_DESC}
      title={title}
      trackingName="LoggedOutHomepageMostWatched"
      userShippingRegion={user.shippingRegionCode}
      excludeShopIds={EXCLUDED_SHOP_IDS} // excluding these shop ids removes reverb shipping boxes from results
      maxCount={5}
      largeTiles
      ssr={false}
      indentedMosaic
      displayMobileMosaic
    />
  );
}

const withQuery = withGraphql<Props, HomepageDealsAndStealsListingsQuery.Query>(
  gql`
    query LoggedOutMParticleProfileQuery(
      $mpid: String
    ) {
      me {
        uuid
        profile(input: {
          mpid: $mpid
        }) {
          topCategories
          topCategoryUuids
        }
      }
    }
  `,
  {
    options: (props) => {
      return {
        ssr: false,
        variables: {
          mpid: props.mpid,
        },
      };
    },
  },
);


export const MostWatchedListingsCollection = withQuery(MostWatchedListings);
